import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { API } from '../utils/apiBase';


const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Invalid unsubscribe link.');
      return;
    }

    const unsubscribe = async () => {
      try {
        const response = await axios.get(`${API}/auth/unsubscribe?token=${token}`);
        setStatus('success');
        setMessage(response.data.message || 'You have been unsubscribed.');
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Failed to unsubscribe. The link may be invalid.');
      }
    };
    unsubscribe();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#f8f9fa] flex items-center justify-center px-4" data-testid="unsubscribe-page">
      <div className="max-w-md w-full bg-white p-8 text-center">
        {status === 'processing' && (
          <>
            <Loader2 size={48} className="animate-spin text-[#002fa7] mx-auto mb-4" />
            <h1 className="font-satoshi text-2xl font-bold text-[#0f1115] mb-2">Processing...</h1>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle size={48} className="text-[#10b981] mx-auto mb-4" />
            <h1 className="font-satoshi text-2xl font-bold text-[#0f1115] mb-2">Unsubscribed</h1>
            <p className="text-[#6b7280] mb-4">{message}</p>
            <p className="text-sm text-[#9ca3af]">You will no longer receive marketing emails from Ascend. You can re-subscribe anytime from your dashboard settings.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle size={48} className="text-[#e11d48] mx-auto mb-4" />
            <h1 className="font-satoshi text-2xl font-bold text-[#0f1115] mb-2">Something Went Wrong</h1>
            <p className="text-[#6b7280]">{message}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default Unsubscribe;
